import { Component } from '@angular/core';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { SettingsProjectsChecklistFormComponent } from '../../../components/settings-projects-checklist-form/settings-projects-checklist-form.component';
import { ActivatedRoute } from '@angular/router';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { SettingsRegulationToChecklistComponent } from '../../../components/settings-regulation-to-checklist/settings-regulation-to-checklist.component';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';


@Component({
  selector: 'app-projects-checklist-edit-page',
  imports: [SettingsProjectsChecklistFormComponent, SettingsRegulationToChecklistComponent],
  templateUrl: './projects-checklist-edit-page.component.html',
  styleUrls: ['./projects-checklist-edit-page.component.scss']
})
export class ProjectsChecklistEditPageComponent {
  checklistId!: number;
  checklist?: any;

  jurisdictionId!: number
  lawId!: number;

  constructor(
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService
  ) {}

  ngOnInit(): void {
    this.checklistId = Number(this.route.snapshot.paramMap.get('checklistId'));
    if (this.checklistId) {
      this.loadData(this.checklistId);
    }
  }

  loadData(checklistId: any): void {
    this.projectsService.detailSettingsChecklist(checklistId).subscribe((response: any) => {
      if (response && response.data && response.data.checklist) {
        this.checklist = response.data.checklist;
      } else {
        this.checklist = response;
      }
      
      if (this.checklist && this.checklist.jurisdiction && this.checklist.jurisdiction.jurisdictionId) {
        this.jurisdictionId = this.checklist.jurisdiction.jurisdictionId;
        
        if (this.checklist.law && this.checklist.law.lawId) {
          this.lawId = this.checklist.law.lawId;
        } else if (this.checklist.lawId) {
          this.lawId = this.checklist.lawId;
        }
      }
    });
  }

  onProjectFormSavedData(savedDataInfo: SavedDataInfo): void {
    if (savedDataInfo.success) {
      this.alertNotificationService.success('Checklist saved successfully.');
    }
  }

  onFieldChange(event: { jurisdiction: number; law: number }): void {    
    
    if (event.jurisdiction !== undefined) {
      this.jurisdictionId = event.jurisdiction;
    }
    
    if (event.law !== undefined) {
      this.lawId = event.law;
    } else {
      this.lawId = 0;
    }
  }
}
